<template>
  <Input placeholder="Search" type="search" />
</template>

<script>
export default {
  name: "Search"
};
</script>

<style lang="stylus" scoped>
#type-search
  width: 18%
  font-size: 15px
  line-height: 40px
  padding: 0px 10px 0px 35px
  margin-left: auto
  margin-right: 10px
  background-image: url('../assets/images/search.svg')
  background-repeat: no-repeat
  background-size: 17px 17px
  background-position: 10px center
</style>
